export default __webpack_public_path__ + "99ef92610c9b3bfae4b726557d9a15d9.svg";